import React, { useState, useEffect } from 'react'
import { KnovaImage } from '../../BasicUIComponents/KnovaImage'
import LayoutHeadDesc from './LayoutHeadDesc'

function LayoutImageHeading(props) {
  const { themeName, layoutData, layoutType, themeProperties, isSideMenu } =
    props
  const [textData, setTextData] = useState([])
  const [imageComponentData, setImageComponentData] = useState({})

  useEffect(() => {
    let textDataCopy = layoutData.filter(
      (e) => e.PluginId === 'SCTextArea' || e.PluginId === 'SCTitle'
    )
    let imageComponentDataCopy = layoutData.filter(
      (e) => e.PluginId !== 'SCTextArea' && e.PluginId !== 'SCTitle'
    )
    setTextData(textDataCopy)
    setImageComponentData(imageComponentDataCopy[0])
  }, [])

  function renderImage() {
    return (
      <KnovaImage
        imgSource={imageComponentData.Url}
        objectFit='cover'
        borderRadius={
          layoutType === 'A' || layoutType === 'B'
            ? '14.71px 0px 0px 14.71px'
            : '0px 14.71px 14.71px 0px'
        }
      />
    )
  }

  function renderDescription() {
    return (
      <LayoutHeadDesc
        fromImage={true}
        themeName={themeName}
        layoutData={textData}
        layoutId={3}
        layoutType={
          layoutType === 'A' || layoutType === 'C' ? 'bottom-left' : 'top-left'
        }
        themeProperties={themeProperties}
        isSideMenu={isSideMenu}
      />
    )
  }

  return (
    <div className='layout-img-head'>
      <div className='image-body'>
        {textData.length > 0 &&
          (layoutType === 'A' || layoutType === 'B'
            ? renderImage()
            : renderDescription())}
      </div>
      <div className='heading-body'>
        {textData.length > 0 &&
          (layoutType === 'A' || layoutType === 'B'
            ? renderDescription()
            : renderImage())}
      </div>
    </div>
  )
}
export default LayoutImageHeading
